import { render, staticRenderFns } from "./order-deduction-list.vue?vue&type=template&id=5582074c"
import script from "./order-deduction-list.vue?vue&type=script&lang=js"
export * from "./order-deduction-list.vue?vue&type=script&lang=js"
import style0 from "./order-deduction-list.vue?vue&type=style&index=0&id=5582074c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports